import {WidgetAppSummaryV0ValueAppDto} from "./models/widget-app-summary-v0-value-app.dto";
import {WidgetAppSummaryV0QueryResponseDto} from "./models/widget-app-summary-v0-query-response.dto";
import {AppAssessmentLevel} from "it/primatoo/openapi/api/org/schemas/appassessment/AppAssessmentLevel";

export class WidgetAppSummaryUtils {

  static alignWidgetApp(widgetValueApp: WidgetAppSummaryV0ValueAppDto[], queryValues: WidgetAppSummaryV0QueryResponseDto[]): WidgetAppSummaryV0ValueAppDto[] {
    const response: WidgetAppSummaryV0ValueAppDto[] = [];
    queryValues.forEach(q => {
      if (q.treatmentSelected) {
        const prevValue = widgetValueApp.find(a => a.applicationUuid === q.uuid);
        if (prevValue) {
          // USO I RID GIA SALVATI
          response.push({
            ...prevValue,
            unsupported: q.appAssessmentUnsupported
          });
        } else {
          // NUOVO WIDGET
          response.push(WidgetAppSummaryUtils.fromWidgetAppSummaryV0QueryResponseDto(q))
        }
      }
    })
    return response;
  }

  private static fromWidgetAppSummaryV0QueryResponseDto(q: WidgetAppSummaryV0QueryResponseDto): WidgetAppSummaryV0ValueAppDto {
    const response: WidgetAppSummaryV0ValueAppDto = {
      applicationUuid: q.uuid,
      unsupported: q.appAssessmentUnsupported,
      scenarioRImplValue: q.scenarioRImplValue,
      scenarioIImplValue: q.scenarioIImplValue,
      scenarioDImplValue: q.scenarioDImplValue,
      scenarioRLevel: q.scenarioRLevel,
      scenarioILevel: q.scenarioILevel,
      scenarioDLevel: q.scenarioDLevel
    }
    return response;
  }
}
